import {gsap, ScrollTrigger} from "../LibrariesImport";

export default class ButtonsMouseTrap {
	static init() {
		this.blocks = document.querySelectorAll(".block-marquee");

		if (ScrollTrigger.isTouch !== 1) {
			this.initButtons();
		}
	}

	static initButtons() {
		this.blocks.forEach( (block) => {
			const btn = block.querySelector(".marquee-cta-mousetrap");

			if (btn) {
				const inner = btn.querySelector(".inner");

				// Configuration de base pour les animations
				const btnConfig = {duration: 0.5, ease: "power2.out"};
				const innerConfig = {duration: 0.3, ease: "power2.out"};

				// Création des fonctions quickTo avec des configurations distinctes
				const moveBtnPosition = {
					top: gsap.quickTo(btn, "top", btnConfig),
					left: gsap.quickTo(btn, "left", btnConfig)
				};

				// Animations standards pour les autres propriétés
				block.addEventListener("mouseenter", (e) => {
					const blockOffset = block.getBoundingClientRect();

					// Animation de l'apparition
					gsap.to(btn, {
						scale: 1,
						opacity: 1,
						duration: 0.3
					});

					gsap.to(inner, {
						scale: 1,
						rotation: 0,
						duration: 0.3
					});

					// Positionnement initial
					moveBtnPosition.top(e.clientY - blockOffset.top);
					moveBtnPosition.left(e.clientX - blockOffset.left);
				});

				block.addEventListener("mousemove", (e) => {
					const blockOffset = block.getBoundingClientRect();
					moveBtnPosition.top(e.clientY - blockOffset.top);
					moveBtnPosition.left(e.clientX - blockOffset.left);
				});

				block.addEventListener("mouseleave", () => {
					gsap.to(btn, {
						scale: 0.5,
						opacity: 0,
						duration: 0.3
					});

					gsap.to(inner, {
						scale: 0,
						rotation: -90,
						duration: 0.3
					});
				});
			}


		});
	}
}
